import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { TranslateModule } from '@ngx-translate/core'
import { SeFeCardModule } from 'se-fe-card'
import { SeFeLinkModule } from 'se-fe-link'
import { StoreService, HouseholdStoreService } from '@se-po/se-household-setup-data-access-store'
import {
  SeHouseholdSetupFeatureChildContactInfoModule
} from '@se-po/se-household-setup-feature-child-contact-info'
import {
  SeHouseholdSetupFeatureChildInfoModule
} from '@se-po/se-household-setup-feature-child-info'
import {
  SeHouseholdSetupFeatureParentGuardianInfoModule
} from '@se-po/se-household-setup-feature-parent-guardian-info'
import {
  SeHouseholdSetupFeatureSelfInfoModule
} from '@se-po/se-household-setup-feature-self-info'
import {
  SeHouseholdSetupFeatureWhosParticipatingModule
} from '@se-po/se-household-setup-feature-whos-participating'
import { SharedUiSetupBarModule } from '@se-po/shared-ui-setup-bar'

import { SetupMembershipComponent } from './setup-membership.component'
import { SePersonaPickerFeaturePersonaPickerModule } from '@se-po/se-persona-picker-feature-persona-picker'

@NgModule({
  declarations: [
    SetupMembershipComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SeFeCardModule,
    SeFeLinkModule,
    SeHouseholdSetupFeatureChildContactInfoModule,
    SeHouseholdSetupFeatureChildInfoModule,
    SeHouseholdSetupFeatureParentGuardianInfoModule,
    SeHouseholdSetupFeatureSelfInfoModule,
    SeHouseholdSetupFeatureWhosParticipatingModule,
    SharedUiSetupBarModule,
    SePersonaPickerFeaturePersonaPickerModule,
    TranslateModule.forChild()
  ],
  exports: [],
  providers: [
    {
      provide: StoreService,
      useClass: HouseholdStoreService,
    },
  ]
})
export class SetupMembershipModule { }
